export function resolvePreviewChrome(input: {
  isOtherChannels: boolean;
  previewError: boolean;
  views_tier_id: string | null;
  season_id: string | null;
  season_name: string | null;
  season_title_id: string | null;
}): {
  showChrome: boolean;
  showTier: boolean;
  showSeason: boolean;
  views_tier_id: string | null;
  season_name: string | null;
  season_title_id: string | null;
} {
  const showChrome = input.isOtherChannels && !input.previewError;
  const hasTier = Boolean(input.views_tier_id);
  const hasSeasonTitle = Boolean(input.season_title_id);

  return {
    showChrome,
    showTier: showChrome && hasTier,
    showSeason: showChrome && hasSeasonTitle,
    views_tier_id: input.views_tier_id,
    season_name: input.season_name,
    season_title_id: input.season_title_id,
  };
}
